import { render, staticRenderFns } from "./LogoHeading.vue?vue&type=template&id=f2563de0&scoped=true&lang=pug"
import script from "./LogoHeading.vue?vue&type=script&lang=js"
export * from "./LogoHeading.vue?vue&type=script&lang=js"
import style0 from "./LogoHeading.vue?vue&type=style&index=0&id=f2563de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2563de0",
  null
  
)

export default component.exports